// Copyright (c) Docugami, Inc. All rights reserved.

import { selectIsReportPublished } from 'store/reports/selectors';
import { useAppSelector } from './redux';

interface ReportEntryActions {
    canAddEntry: boolean,
    canRemoveEntry: boolean
}

export const useReportEntryActions = (): ReportEntryActions => {
    const isPublished = !!useAppSelector(selectIsReportPublished);

    return {
        canAddEntry: !isPublished,
        canRemoveEntry: !isPublished
    };
}
